
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1485_38245)"}},[_c('path',{attrs:{"d":"M12 23.002c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z","stroke":"#1BA4F7","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.754 7.246a.84.84 0 010 1.189l-3.565 3.564 3.565 3.566a.84.84 0 11-1.189 1.189L12 13.188l-3.565 3.566a.84.84 0 01-1.189-1.189L10.812 12 7.246 8.435a.84.84 0 111.189-1.189L12 10.812l3.566-3.566a.84.84 0 011.188 0z","fill":"#1BA4F7"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1485_38245"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    